/**
 * PreBuilt
 * @version     1.0
 */

(function (globals) {

  "use strict";

  let app = {
    id: null,
    templates: window['templates'],
    calendar: window['calendar'],
    calendarId: window['calendarId'],
    approvalSystem : window['approvalSystem'],
    application: {
      namespace: "PreBuilt", version: "1.0"
    },
    requests: {}, apis: {}, mainContainer: 'body'
  };

  window['__gites'] = [];

  app.localStorage = window.localStorage;
  app.sessionStorage = window.sessionStorage;

  app.version = function () {
    return {
      get: function () {
        return window['appVersion'];
      }, set: function (v) {
        window['appVersion'] = v;
      }
    }
  }();

  app.transport = (function () {

    return function () {
      var testMode = false, sendDataAsJson = true, data = {}, baseUrl = window['appUrl'], request = {
        async: true, beforeSend: function () {
        }, cache: true, complete: function () {
        }, data: {}, processData: false, contentType: false, error: function () {
        }, global: true, ifModified: false, success: function () {
        }, timeout: 300000, type: "GET", url: "", headers: {
          'X-Source': 'ACRE Mobile'
        },
      };
      var events = {
        onBeforeSend: null,
        onProgress: null,
        onSuccess: null,
        onComplete: null,
        onError: null,
        onTimeout: null,
        onAuthenticationFailure: app.authenticationFailure
      };

      return {
        'getEvents': function () {
          return events;
        }, xhr: function () {
          return $.ajaxSettings.xhr();
        }, 'get': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "GET";
          if (data) this.setRequestData(data, true);
          this.prepare(url);
        },

        'head': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "HEAD";
          if (data) this.setRequestData(data, true);
          this.prepare(url);
        },

        'post': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "POST";
          if (data) this.setRequestData(data, true);
          this.prepare(url);
        },

        'put': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "PUT";
          if (data) this.setRequestData(data, true);
          this.prepare(url);
        },

        'delete': function (url, data, testMode) {
          this.setTestMode(testMode || false);
          request.type = "DELETE";
          if (data) this.setRequestData(data, true);
          this.prepare(url);
        },

        'setBaseUrl': function (url) {
          baseUrl = url;
          return this;
        },

        'setRequestParam': function (param, value) {
          if (param == 'data') return this.setRequestData(value);
          request[param] = value;
          return this;
        },

        setRequestData: function (obj, asJson) {
          sendDataAsJson = (asJson !== false);
          data = obj;
          if (sendDataAsJson === true) {
            request.dataType = "json";
            request.contentType = 'application/json; charset=UTF-8';
          }
          return this;
        },

        setResponseData: function (serializeObject) {
          request.data.serializer = JSON.stringify(serializeObject);
          return this;
        },

        setEvent: function (event, callback) {
          if (typeof callback !== "function") throw (app.log('Error: Event callback is not a function', 'error'));
          events[event] = callback;
          return this;
        },

        setTestMode: function (boolVal) {
          testMode = (boolVal === true);
          return this;
        },

        prepare: function (url) {
          let user = app.apis['user'].get(), acre_token = '', key = '';

          if (!_.isEmpty(user)) {
            acre_token = window.btoa(`${user.authToken}::${user.id}`);
            key = md5(`${url}::${user.id}`);
          }

          // check URL
          url += (url.indexOf('?') > -1) ? '&acre_token=' + acre_token : '?acre_token=' + acre_token;
          url += '&device=web';

          request.headers['X-Cache-Key'] = key;

          let hasKey = !!(app.localStorage.getItem(request.headers['X-Cache-Key']));
          url += '&has_data=' + hasKey;

          if (hasKey) {
            request.headers['X-Cache-Checksum'] = app.localStorage.getItem(key + '-checksum');
          }

          this.send(baseUrl + url);
        },

        send: function (url) {
          request.url = url;
          var logKey = request.url.split("?")[0] + '__' + request.type;

          // error with url
          if (!request.url) {
            events.onComplete();
            events.onError({code: 0, message: 'Null or invalid url supplied to ajax call.'});
            return false;
          }

          // prepare data
          if (sendDataAsJson && request.type != 'GET' && request.type != 'HEAD') {
            if (typeof data == "object") {
              data = JSON.stringify(data);
            }
            request.data = data;
          } else {
            if (data instanceof FormData) {
              request.data = data;
            } else if (typeof data == "object" && request.type != 'GET' && request.type != 'HEAD') {
              request.data = JSON.stringify(data);
            } else {
              $.extend(request.data, data);
            }
          }

          request.xhr = function () {
            // Create XMLHttpRequest object
            const xhr = new XMLHttpRequest();
            // Upload progress event listener
            xhr.upload.addEventListener('progress', function (event) {
              if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                if (typeof events.onProgress == 'function') {
                  events.onProgress(event, percentComplete);
                }
              }
            }, false);
            return xhr;
          }

          request.beforeSend = function (jqXHR, settings) {
            if (typeof events.onBeforeSend == 'function') {
              events.onBeforeSend(jqXHR, settings);
            }
          };

          request.success = function (responseData, textStatus, jqXHR) {
            delete app.requests[md5(request.url)];
            window['__gites'][logKey] = {
              'status': jqXHR.status, 'response': responseData, 'data': request.data, 'url': request.url
            };

            if (jqXHR.status == 204) {
              responseData = JSON.parse(app.localStorage.getItem(request.headers['X-Cache-Key']));
            }

            if (jqXHR.status == 200) {
              // @todo to move to cache api as per conversation with Amin dated 19th August 2020
              //app.localStorage.setItem(request.headers['X-Cache-Key'], JSON.stringify(responseData));
              //app.localStorage.setItem(request.headers['X-Cache-Key'] + '-checksum', responseData.checksum);
            }

            if (typeof events.onSuccess == 'function') {
              events.onSuccess(responseData, textStatus, jqXHR);
            }
          };

          request.complete = function (jqXHR, textStatus) {
            delete app.requests[md5(request.url)];

            // Logout user on 401 unauthorized
            if (jqXHR.status == 401) {
              app.apis['user'].logout();
              window.location.replace('/login');
            }

            if (typeof events.onComplete == 'function') {
              events.onComplete(jqXHR, textStatus);
            }
          };

          request.error = function (jqXHR, textStatus, errorThrown) {
            delete app.requests[md5(request.url)];
            let error;

            console.error("AJAX Error:", textStatus, errorThrown);
            // Check if the error is likely a preflight failure
            if (jqXHR.status === 0 && textStatus === "error") {
              // Notify the user of any API call failures after a short delay.
              setTimeout(function () {
                if(!app.isEmpty(app.notifyEl)) {
                  app.notifyEl.update({
                    progress:100
                  });
                }

                app.notify('error', "Preflight request failed. Check your CORS policy on the server.", false, {
                  auto_hide: false,
                  delay: 100000,
                  allow_dismiss: true
                });
              }, 400);
            }

            if (jqXHR.status === 403 && typeof events.onAuthenticationFailure == 'function') {
              events.onAuthenticationFailure(jqXHR, textStatus, errorThrown);
            } else if (typeof events.onError == 'function') {
              if (jqXHR.responseJSON) {
                error = {
                  code: jqXHR.status, message: jqXHR.responseJSON
                };
              } else {
                error = {
                  code: jqXHR.status, message: ((jqXHR.responseText) ? jqXHR.responseText : "An error has occurred")
                };

                error.message = {'message': error.message};
              }
              events.onError(error);
            }

            window['__gites'][logKey] = {
              'status': jqXHR.status, 'response': error, 'data': request.data, 'url': request.url
            };
          };

          if (testMode) {
            var testResponse = {};
            for (var param in request) {
              if (typeof request[param] != 'function') {
                testResponse[param] = request[param];
              }
            }

            for (var event in this.getEvents()) {
              if (typeof this.getEvents()[event] == 'function') {
                testResponse[event] = this.getEvents()[event].toString();
              }
            }

            if (typeof events.onComplete == 'function') {
              events.onComplete({}, "test", {});
            }
          } else {
            app.request = $.ajax(request);
            app.requests[md5(request.url)] = app.request;
          }
        }, parseResponse: function (jqXHR) {
          var content_type;
          var jsonResponse = {};
          content_type = jqXHR.getResponseHeader('content-type');

          if (content_type) {
            if (content_type.match(/json/)) {
              try {
                jsonResponse = $.parseJSON(jqXHR.responseText);
              } catch (error) {
                console.error("non-standard json response received");
              }
            } else if (content_type.match(/javascript/)) {
              jsonResponse = jqXHR.responseText;
            } else if (content_type.match(/html/)) {
              jsonResponse = {
                html: jqXHR.responseText
              };
            } else {
              console.error("non-standard xhr response received of type: " + content_type);
            }
          }

          return jsonResponse;
        }
      };
    };
  })();

  /**
   * Generate a random string
   * @returns {string}
   */
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
  }

  /**
   * Generate a random dom id
   * @returns {string}
   */
  app.generateId = function () {
    return 'dom' + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4()
  };

  /**
   * Buttons loading reset
   * @param buttons
   * @param fn
   * @returns {*}
   */
  app.button = function (buttons, fn) {
    var _this = buttons;
    if (fn == 'loading') {
      return _this.each(function () {
        var $this = $(this);
        $this.attr('disabled', 'disabled').css({'opacity': 0});
        if ($this.parent('.dot-pulse-container').length == 0) {
          $this.wrap('<div class="dot-pulse-container ">  </div>');
          $this.parent('.dot-pulse-container').width($this.outerWidth());
        }
        $('<div class="dot-pulse-wrapper"><div class="dot-pulse"></div></div>').insertAfter($this);
      });
    }
    if (fn == 'reset') {
      return _this.each(function () {
        var $this = $(this);
        $this.removeAttr('disabled').css({'opacity': 1});
        $this.parent().find('.dot-pulse-wrapper').remove();
        var originalText = $(this).attr('data-original-text');
        if (originalText) {
          $(this).text(originalText);
        }
      });
    }
  };

  /**
   * Loader
   * @returns {{show: Function, hide: Function}}
   * @type {{show, hide}}
   */
  app.loader = function () {
    let loaderTimeout = null;
    return {
      'show': function (loader = '#aimi-loader') {
        $(loader).show();

        // Set loader timeout.
        clearTimeout(loaderTimeout);
        loaderTimeout = setTimeout(() => {
          app.loader.hide(loader, false);
          app.track('/app-loader-hide-timeout');
        }, 3000);
      }, 'showPersistent': function (loader = '#aimi-loader') {
        $(loader).show();
      }, 'hide': function (loader = '#aimi-loader', force = false) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;

        // Check if any request completed but not deleted
        _.each(app.requests, function (request, key) {
          if (request.readyState == 4) {
            delete app.requests[key];
          }
        });

        if (_.isEmpty(app.requests) || force) {
          $(loader).hide();
        } else {
          // If hide is called and requests still in progress wait for request to complete and hide the loader
          setTimeout(() => {
            app.loader.hide(loader, force);
          }, 500);
        }
      }
    };
  }();

  /**
   * Lazy Load Image
   * @param container
   * @param callback
   * @param callbackAll
   */
  app.lazyLoadImage = function (container, callback, callbackAll) {
    $('.lazy:not(.loaded)', container).lazy({
      bind: 'event', // called before an elements gets handled
      beforeLoad: function (element) {
        var imageSrc = element.data('src');
        element.parent().addClass('m-progress');
      },

      // called after an element was successfully handled
      afterLoad: function (element) {
        var imageSrc = element.data('src');
        element.parent().removeClass('m-progress');
        element.addClass('loaded');

        if (callback) callback(element);
      },

      // called whenever an element could not be handled
      onError: function (element) {
        var imageSrc = element.data('src');
        console.log('image "' + imageSrc + '" could not be loaded');
      },

      // called once all elements was handled
      onFinishedAll: function () {
        if (callbackAll) callbackAll();
      }
    });
  };


  /**
   * Lazy Load svg
   * @param container
   * @param callback
   * @param callbackAll
   */
  app.lazyLoadSvg = function (container, callback, callbackAll) {
    $('.svg-object:not(.loaded)', container).each(function () {
      let $this = $(this);
      if ($this.data('src')) {
        $this.parent().addClass('m-progress');
        $this.attr('data', $this.data('src'));
        $this.on('load', function () {
          if (callback) callback($this);
          $this.addClass('loaded');
          $this.parent().removeClass('m-progress');
        });
      }
    })
  };

  /**
   * Assign id to an element
   * @returns {jQuery|HTMLElement}
   */
  $.fn.assignId = function () {
    var _self = $(this);
    var id = _self.attr('id');
    if (typeof id === typeof undefined || id === false) {
      id = app.generateId();
      _self.attr('id', id);
    }
    return _self;
  };

  /**
   * Load Tab
   * @param module ( module Name)
   * @param $tab ( $tab to load )
   * @param $context ( Context )
   * @param callback ( Callback function if any )
   */
  app.loadTab = function (module, $tab, $context, callback) {
    let query = $.Deferred();
    if ($tab.length && !$tab.data('loaded')) {
      app.loader.show();
      var $dataTab = $tab.data('tab');
      app.load($('.' + $dataTab, $context), 'modules/' + module + '/partials/tab-' + $.trim($dataTab.replace('md-tab-', '')) + '.html', function (e) {
        $tab.data('loaded', true);
        $(this).trigger('mbsc-enhance');
        query.resolve();
        if (typeof callback == 'function') {
          callback();
        } else {
          app.loader.hide();
        }
      });
    } else {
      query.resolve();
      if (typeof callback == 'function') {
        callback();
      }
    }
    app.loadTabPromise = query.promise();
    return query.promise();
  };

  /**
   * Keep track of modals
   * @type {Array}
   */
  app.modals = [];

  /**
   * On show modal ( necessary to have in all modals with full height)
   * It keep tracks of all modals ( Hide all open ones ) and only show the current one
   * @param modal
   */
  app.onShowModal = function (modal) {
    $.each(app.modals, function () {
      this.markup.style.display = 'none';
    });
    app.modals.push(modal);
  };

  /**
   * On hide modal ( necessary to have in all modals with full height) and using app.onShowModal
   * It shows the last modal which was already opened and being hide from app.onShowModal
   */
  app.onHideModal = function () {
    app.modals.pop();
    if (app.modals.length > 0) {
      app.modals[app.modals.length - 1].markup.style.display = 'block';
    }
  };

  /**
   * Get address from google using zip code
   * @param callback
   */
  $.fn.getAddressFromZip = function (callback) {
    var address = $(this).val();
    var geoCoderData = {};
    var geocoder = new google.maps.Geocoder();

    geocoder.geocode({
      'address': address
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        _.each(results[0].address_components, function (item, value) {

          var inArray = $.inArray('locality', item.types);
          if (inArray != -1 && inArray != undefined) {
            geoCoderData['city'] = item.long_name;
          }

          var inArray = $.inArray('administrative_area_level_1', item.types);
          if (inArray != -1 && inArray != undefined) {
            geoCoderData['state'] = item.long_name;
          }

          var inArray = $.inArray('country', item.types);
          if (inArray != -1 && inArray != undefined) {
            geoCoderData['country'] = item.long_name;
          }

        }, this);
        callback.call(this, geoCoderData);
      } else {
        geoCoderData['city'] = '';
        geoCoderData['state'] = '';
        geoCoderData['country'] = '';
        callback.call(this, geoCoderData);
      }
    });
  };

  // SerializeObject
  $.fn.serializeObject = function () {
    return this.serializeJSON();
  };

  /**
   * Create deep copy of array or object.
   * @param {object} thing
   * @returns {any}
   */
  app.clone = function (thing) {
    return JSON.parse(JSON.stringify(thing));
  };

  /**
   * Set or get  a css variable // to set pass name and value // to get simply pass the name;
   * @param name
   * @param value
   * @param unit
   * @returns {string}
   */
  app.cssVar = function (name, value, unit = 'px') {
    if (name[0] != '-') name = '--' + name //allow passing with or without --
    if (value) document.documentElement.style.setProperty(name, value + unit);
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  };

  /**
   * Load a file using jquery load
   * @param $container
   * @param filePath
   * @param callback
   */
  app.load = function ($container, filePath, callback) {
    $container.load(`${fileUrl}/${filePath}?__=${app.version.get()}`, callback)
  };

  /**
   * This function is same as PHP's nl2br() with default parameters.
   * @param {string} str Input text
   * @return {string} Filtered text
   */
  app.nl2br = function (str, replaceMode, isXhtml) {
    let breakTag = '<br>';
    let replaceStr = '$1' + breakTag + '$2';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
  };

  /**
   * Strip leading hashtag.
   * @param value
   * @returns {string}
   */
  app.sanitizeHashtag = function (value) {
    value = value.toString();
    return value.replace(/#/g, '');
  };

  app.track = function (route) {

  };

  app.trackWithMessage = function (route, message) {

  };

  $.fn.hasAnyClass = function () {
    for (var i = 0; i < arguments.length; i++) {
      var classes = arguments[i].split(" ");
      for (var j = 0; j < classes.length; j++) {
        if (this.hasClass(classes[j])) {
          return true;
        }
      }
    }
    return false;
  };

  /**
   * Not allow space
   * @param event
   * @returns {boolean}
   */
  app.avoidSpace = function (event) {
    var k = event ? event.which : window.event.keyCode;
    if (k == 32) return false;
  };

  /**
   * Validate url
   * @param str
   * @returns {boolean}
   */
  app.validateUrl = function (str) {
    var res = str.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,20}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
  };

  $(document).once('click.btn-video-modal').on('click.btn-video-modal', '[data-video]', function () {
    app.videoPopup($(this).data());
  });

  $(document).once('cick.close-guide').on('click.close-guide', '.btn-close-guide', function () {
    app.guide.exit();
  });

  $(document).once('cick.next-guide').on('click.next-guide', '.btn-next-guide', function () {
    app.guide.next();
  });

  app.helpModal = function () {
    return {
      'show': function (url) {
        window.open(url, '_blank', 'location=no,toolbar=yes');
      }
    }
  }();

  $(document).once('click.open-feed').on('click.btn-open-feed', ' .btn-open-feed', function () {
    let $row = $(this).closest('.article-item');
    window.open($row.data('url'), '_blank', 'location=no,toolbar=yes');
  });


  $(document).once('cick.help-modal').on('click.help-modal', '.btn-help-modal', function () {
    let isPersonaView = $(this).parents('.aimi-persona-view-modal').length;
    let url = $(this).data('url');
    if (isPersonaView) {
      let personaUrl = $(this).data('persona-url');
      url = !_.isEmpty(personaUrl) ? personaUrl : url;
    }
    app.helpModal.show(url);
  });

  // Set Global css vars
  app.setGlobalVars = function () {
    app.cssVar('window-height', $(window).height());
    app.cssVar('top-navigation-height', '0', 'px');
  };

  app.isChrome = function () {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  };

  // Call global css vars on document ready and window resize
  (function ($) {
    $(function () {
      app.setGlobalVars();

      if (app.isChrome()) {
        $('body').addClass('browser-chrome');
      }

      $(window).on('resize.global', function () {
        app.setGlobalVars();
      });

    });
  })(jQuery);


  // Function to check if element in viewport
  var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
  };

  app.getAcreToken = function () {
    let user = app.apis['user'].get(), acre_token = '';

    if (!_.isEmpty(user)) {
      acre_token = window.btoa(`${user.authToken}::${user.id}`);
    }
    return acre_token;
  };

  /**
   * Lazy Load svg
   * @param container
   * @param callback
   * @param callbackAll
   */
  app.svgLoader = function (container, callback, callbackAll) {
    $('.svg-object, .post-image', container).each(function () {
      app.loadSvg(this, callback);
    })
  };


  /**
   * Load image
   * @param src
   * @returns {Promise<unknown>}
   */
  app.loadImage = function (src) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', resolve);
      image.addEventListener('error', reject);
      image.src = src;
    });
  }

  /**
   * Create svg Object
   * @param $this
   */
  app.createSvgObject = function ($this) {
    let $parent = $this.parent();
    let dataType = $this.attr('data-type');

    if (dataType === 'image') {

    } else {
      let $object = $('<object></object>').attr({
        'data': $this.attr('data-src'), 'type': $this.attr('data-type'), 'class': $this.attr('class')
      });

      $parent.append($object);
      $this.remove();
      return $object;
    }
    return $this;
  };

  /**
   * Lazy load single svg
   * @param $this
   * @param callback
   */
  app.loadSvg = function ($this, callback) {
    $this = $($this);
    $this.parent().addClass('m-progress');

    if ($this.attr('data-type') == 'image') {
      app.loadImage($this.attr('data-src')).then(() => {
        $this.parent().removeClass('m-progress');
        $this.css({'background-image': 'url("' + $this.attr('data-src') + '")'});
        $this.addClass('loaded');
      });
    } else {
      $this.on('load', function () {
        if (callback) callback($this);
        $this.parent().removeClass('m-progress');
        setTimeout(function () {
          $this.addClass('loaded');
        }, 500);
      });
    }
  };

  app.setCookie = function (cookieName, cookieValue, expirationDays) {
    const d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
  }

  app.getCookie = function (cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return "";
  }

  app.removeCookie = function (cookieName) {
    // Set the expiration date to a past time
    const pastDate = new Date(0);
    const expires = "expires=" + pastDate.toUTCString();

    // Set the cookie with the past expiration date
    document.cookie = cookieName + "=;" + expires + ";path=/";
  }

  app.errorAlert = function (header, message) {
    Swal.fire({
      html: `<div class="d-flex align-items-center">
		<div class="avatar avatar-icon avatar-soft-danger me-3"><span class="initial-wrap rounded-8"><i class="ri-close-circle-fill"></i></span></div>
		<div>
			<h4 class="text-danger">${header}</h4>
			<p>${message}</p>
		</div>
	</div>`, customClass: {
        confirmButton: 'btn btn-outline-secondary text-danger',
        cancelButton: 'btn btn-outline-secondary text-gray',
        container: 'swal2-has-bg',
        content: 'bg-transparent text-start',
      }, showConfirmButton: false, showClass: {
        popup: 'animated fadeInDown faster'
      }, hideClass: {
        popup: 'animated fadeOutUp faster'
      }, showCancelButton: false, buttonsStyling: false, showCloseButton: true
    }).then((result) => {

    })
  }

  /**
   * App Notify
   * @param type
   * @param message
   * @param progress
   * @param options
   * @returns {*}
   */
  app.notify = function (type, message, progress = false, options = {}) {
    let notify;
    let notifyClass = 'dismissible alert-primary';
    if (type === 'success') {
      notifyClass = 'dismissible alert-success';
    }
    if (type === 'error') {
      notifyClass = 'dismissible alert-danger';
    }

    setTimeout(function () {
      $('.alert.alert-dismissible .close').addClass('btn-close').removeClass('close');
    }, 100);

    let delay = 5000;
    if (progress === true) {
      delay = 30000;
    }

    const defaults = {
      animate: {
        enter: 'animated bounceInDown', exit: 'animated bounceOutUp'
      },
      type: notifyClass,
      placement: {
        from: "top", align: "right"
      },
      allow_dismiss: true, delay: delay, showProgressbar: progress,
    };

    options = {...defaults, ...options};
    app.notifyEl = $.notify(message, options);

    return app.notifyEl;
  }

  let audioContext = new (window.AudioContext || window.webkitAudioContext)();

  // Function to play click sound
  app.playClickSound = function () {
    // Create an oscillator node
    const oscillator = audioContext.createOscillator();
    // Create a gain node to control the volume
    const gainNode = audioContext.createGain();

    // Set the oscillator to a sine wave for a smooth sound
    oscillator.type = 'sine';
    // Choose a relatively low frequency for the soft click
    oscillator.frequency.setValueAtTime(1000, audioContext.currentTime); // Lower frequency for a softer click

    // Start with a low volume
    gainNode.gain.setValueAtTime(0.1, audioContext.currentTime); // Soft start volume
    // Ramp down the volume quickly but smoothly
    gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.05); // Softer and longer ramp for a gentle fade out

    // Connect the oscillator to the gain node and the gain node to the destination
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    // Start the oscillator
    oscillator.start(audioContext.currentTime);
    // Stop the oscillator after a short duration to create a soft click sound
    oscillator.stop(audioContext.currentTime + 0.05);
  };

  app.executeFunctionByName = function (functionName, context /*, args */) {
    let args = Array.prototype.slice.call(arguments, 2)
    let namespaces = functionName.split(".");
    let func = namespaces.pop();
    for (let i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }
    //console.log(context, func, args);
    return context[func].apply(context, args);

  }

  app.confirmAlert = function () {

    Swal.fire({
      html: `<div class="d-flex align-items-center">
		<div class="avatar avatar-icon avatar-soft-danger me-3"><span class="initial-wrap rounded-8"><i class="ri-close-circle-fill"></i></span></div>
		<div>
			<h4 class="text-danger">Oops! API validation failed</h4>
			<p>Please add a valid format for API and try again.</p>
		</div>
	</div>`,
      customClass: {
        confirmButton: 'btn btn-outline-secondary text-danger',
        cancelButton: 'btn btn-outline-secondary text-gray',
        container: 'swal2-has-bg',
        content: 'bg-transparent border-bottom text-start',
      },
      showClass: {
        popup: 'animated fadeInDown faster'
      },
      hideClass: {
        popup: 'animated fadeOutUp faster'
      },
      showCancelButton: true,
      buttonsStyling: false,
      showCloseButton: true,
      confirmButtonText: 'TRY AGAIN',
      cancelButtonText: 'CLOSE',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          html: '<div class="d-flex align-items-center"><i class="ri-delete-bin-5-fill me-2 fs-3 text-danger"></i><h5 class="text-danger">Your file has been deleted!</h5></div>',
          customClass: {
            content: 'p-0 text-start', confirmButton: 'btn btn-primary', actions: 'justify-content-start',
          },
          buttonsStyling: false,
        })
      }
    })
  }

  app.autoLink = function (text) {
    // Match URLs
    text = text.replace(/(https?:\/\/\S+)/g, '<a href="$1" target="_blank">$1</a>');

    // Match email addresses
    text = text.replace(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g, '<a href="mailto:$&">$&</a>');

    return text;
  }

  app.infoModal = function (title, description, options = {}) {
    const id = 'infoModal';
    const defaults = {
      dialogClass: 'modal-dialog-scrollable',
      footerText: '',
      headerHtml:'',
      'saveButton': 'd-none',
      saveButtonText: ''
    };
    options = {...defaults, ...{id: id}, ...options};

    let $modal = $(`#${options.id}`);

    if ($modal.length) {
      $modal.remove();
    }

    let modal = `
      <div class="modal fade ${options.dialogClass}-modal" id="${options.id}" tabindex="-1" role="dialog" aria-labelledby="${options.id}" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered ${options.dialogClass}" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">${title}</h5>
                       ${options.headerHtml}
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      ${description}
                  </div>
                  <div class="modal-footer w-100">
                    <div class="row w-100 align-items-center">
                      <div class="col text-start ">
                         ${options.footerText}
                      </div>
                      <div class="col-auto  ms-auto text-end ">
                        <div class="d-flex justify-content-end">
                          <button type="button" class="btn btn-secondary btn-confirm-close" data-bs-dismiss="modal">Close</button>
                          <div class="ms-3 ${options.saveButton} btn-save-button">
                            <button type="submit" class="btn btn-primary btn-confirm w-100">${options.saveButtonText}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>`;

    let $prompt = $(modal).appendTo($('body'));
    $prompt.modal('show');

    let response = $prompt;
    response.promise = new Promise((resolve, reject) => {
      $('.btn-confirm', $prompt).off('click').on('click', function (e) {
        return resolve({'modal': $prompt, 'button': $(this), 'confirm': true});
      })
      $('.btn-confirm-close', $prompt).off('click').on('click', function (e) {
        return resolve({'modal': $prompt, 'button': $(this), 'confirm': false});
      })
    });

    return response;
  }

  app.hideModal = function ($modal) {
    $modal.modal('hide');
  }

  app.hideToast = function () {
    $.toast().reset('all');
  }

  app.confirm = function (title, description, options = {'confirmButtonText' : 'Confirm'}) {
    let $confirmModal = $('#confirmModal');
    if ($confirmModal.length) {
      $confirmModal.remove();
    }

    let confirm = `
      <div class="modal fade" id="confirmModal" tabindex="-1" role="dialog" aria-labelledby="confirmModal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                      <h5 class="modal-title">${title}</h5>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <p>${description}</p>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary btn-confirm-close" data-bs-dismiss="modal">Close</button>
                      <button type="button" class="btn btn-primary btn-confirm">${options.confirmButtonText}</button>
                  </div>
              </div>
          </div>
      </div>`;

    let $confirm = $(confirm).appendTo($('body'));
    $confirm.modal('show');

    return new Promise((resolve) => {
      $confirm.off('click', '.btn-confirm').on('click', '.btn-confirm', function () {
        resolve({ modal: $confirm, button: $(this), confirm: true });
      });

      $confirm.off('click', '.btn-confirm-close').on('click', '.btn-confirm-close', function () {
        resolve({ modal: $confirm, button: $(this), confirm: false });
      });
    });
  }

  app.bulkConfirm = function (title, description, button = {}) {
    $.toast().reset('all');
    $("body").addClass("bottom-center-fullwidth");
    let $confirm = `
      <div class="bulk-confirm">
        <div class="f-5 fw-bold pb-2">
          ${title}
        </div>
        <div class="row align-items-center align-center">
           <div class="col text-end">
            ${description}
          </div>
          <div class="col text-start">
            <button type="button" class="btn ${button.class} btn-confirm">
              ${button.text}
            </button>
          </div>
        </div>
      </div>
      `;
    $.toast({
      "closeButton": true,
      text: $confirm,
      position: 'bottom-center',
      class: 'jq-toast-inv bg-gradient-dusk',
      hideAfter: false,
      textAlign: 'center',
      stack: 6,
      loader: true,
      showHideTransition: 'fade'
    });

    $confirm = $('.bulk-confirm');
    return new Promise((resolve, reject) => {
      $('.btn-confirm', $confirm).off('click').on('click', function (e) {
        return resolve({'modal': $.toast, 'button': $(this), 'confirm': true});
      });

      $('.close-jq-toast-single').off('click.close').on('click.close', function (e) {
        return resolve({'modal': $.toast, 'button': $(this), 'confirm': false});
      });

    });
  }

  app.inputPrompt = function (params) {
    const modalId = 'inputPromptModal';

    const defaults = {
      payloadProcessor: '',
      template: '',
      id: '',
      modalId: modalId,
      value: '',
      footerText: '',
      formName : 'prompt-form',
      saveButtonText: 'Save',
      modalDialogClass: 'modal-md'
    };

    params = {...defaults, ...params};

    let $modal = $(`#${params.modalId}`);

    if ($modal.length) {
      $modal.modal('hide');
      $modal.remove();
    }

    if (params.template) {
      const template = _.template(app.templates[params.template]);
      params.template = template(params);
    }

    let modal = _.template(app.templates['global__prompt'])(params);

    $modal = $(modal);
    let $prompt = $modal.appendTo($('body'));
    $prompt.modal('show');

    let forms = $prompt[0].querySelectorAll('.needs-validation');

    console.log(forms);

    // Attach validation to forms
    app.addValidationToForms(forms);

    return new Promise((resolve, reject) => {
      $modal[0].addEventListener('shown.bs.modal', event => {
        $('#inputField', $modal).focus();
        return resolve($modal, true);
      })
    });
  }

  /**
   * Adds submission validation and processing to a collection of forms.
   *
   * This function iterates over each form in the provided collection, attaching a submit event listener
   * that prevents the default form submission, validates the form, and, if valid, processes the form data.
   * The processing includes playing a click sound, potentially manipulating the data, sending it to a specified API endpoint,
   * and handling the response with either a page reload or a custom callback function.
   *
   * @param {HTMLFormElement[]} forms - An array or collection of form elements to which validation and submission handling will be added.
   */
  app.addValidationToForms = function (forms) {
    // Convert the forms NodeList to an array for easier manipulation.
    Array.prototype.slice.call(forms)
        .forEach(function (form) { // Iterate over each form in the array.
          // Add a 'submit' event listener to each form.
          form.addEventListener('submit', function (event) {
            // Capture the button (or input type="submit") that triggered the form submission.
            const $button = $(event.submitter);
            // Wrap the form element with jQuery for easier manipulation.
            const $form = $(form);
            // Prevent the default form submission to handle it via JavaScript.
            event.preventDefault();
            // Stop the propagation of the event to avoid triggering handlers up the DOM tree.
            event.stopPropagation();
            // Play a click sound for interactive feedback.
            app.playClickSound();

            // Check if the form is valid according to HTML5 validation.
            if (!form.checkValidity()) {
              // Notify the user of validation errors.
              app.notify('error', 'Please fill in or check all required fields');
            } else {
              // Retrieve custom payload processing information, if available.
              const payloadProcessor = $form.data('api-payload');
              // Retrieve the API endpoint or action from form data attributes.
              const dataApi = $form.data('api');
              // Split the dataApi string into a usable format if it contains multiple parts.
              const api = dataApi.split('.');
              // Get the callback function name to be called after successful API call.
              const apiCallBack = $form.data('api-callback');
              // Check if the form supports multiple submissions.
              const multiple = $form.data('multiple');

              let validated = true;
              // Check if the form supports multiple submissions.
              const validateMultiple = $form.data('validate');
              if (typeof validateMultiple !== 'undefined' && validateMultiple === 'multiple') {
                const formName = $form.attr('name');
                const forms = $(`form[name="${formName}"]`);
                _.each(forms, function (nform) {
                  const $nform = $(nform);
                  console.log($nform,nform.checkValidity() );
                  if (!nform.checkValidity()) {
                    $nform.addClass('was-validated');
                    validated = false;
                    app.notify('error', 'Please fill in or check all required fields');
                  }
                })
              }

              if (validated === false) {
                return false;
              }

              // Serialize the form data into an object for submission.
              let requestData = $form.serializeObject();
              // If 'multiple' is defined, serialize all forms with the same name attribute.
              if (typeof multiple !== 'undefined') {
                const formName = $form.attr('name');
                requestData = $(`form[name="${formName}"]`).serializeObject();
              }
              // Process requestData through a custom function if specified.
              if (typeof payloadProcessor !== 'undefined' && !app.isEmpty(payloadProcessor)) {
                requestData = app.executeFunctionByName(payloadProcessor, window, requestData);
              }

              if (app.isEmpty(requestData)) {
                const response = {};
                // Handle other API responses with a callback after a short delay.
                setTimeout(function () {
                  response.$button = $button;
                  response.payload = requestData;
                  app.executeFunctionByName(apiCallBack, window, response);
                }, 400);
                return false;
              }

              if (app.isEmpty(api)) {
                // Perform an action with the button (e.g., showing loading state).
                app.doButtonAction($button);
                // Handle other API responses with a callback after a short delay.
                setTimeout(function () {
                  app.doButtonReset($button);
                  app.executeFunctionByName(apiCallBack, window, requestData);
                }, 400);
                return false;
              }

              if (!app.isEmpty(api) && (_.isUndefined(app.apis[api[0]]) || _.isUndefined(app.apis[api[0]][api[1]]))) {
                app.notify('error', 'Api Endpoint invalid');
                return false;
              }

              // Perform an action with the button (e.g., showing loading state).
              app.doButtonAction($button);

              // return false;
              // Perform the API call and handle the response.
              $.when(app.apis[api[0]][api[1]](requestData)).done(function (response) {
                // Handle other API responses with a callback after a short delay.
                setTimeout(function () {
                  response.$button = $button;
                  response.payload = requestData;
                  app.executeFunctionByName(apiCallBack, window, response);
                }, 400);

                // Special handling for a login action.
                if (dataApi === 'user.login') {

                } else {

                }
                // Reset the button state regardless of the API call outcome.
                app.doButtonReset($button);
              }).fail(function (response) {
                console.log(response);
                // Notify the user of any API call failures after a short delay.
                setTimeout(function () {
                  app.notifyEl.update({
                    progress:100
                  });
                  app.notify('error', response.message.message, false, {
                    auto_hide: false,
                    delay: 100000,
                    allow_dismiss: true
                  });
                }, 400);
              }).always(function (response) {
                // Reset the button state regardless of the API call outcome.
                app.doButtonReset($button, false);
              });
            }
            // Add a class to the form indicating it was validated (useful for CSS styling).
            form.classList.add('was-validated');
          }, false); // The third argument `false` specifies that the event should not be captured during the capturing phase.
        });
  };

  app.removeEmptyValues = function (array) {
    return array.filter(element => element !== "" && element != null);
  }

  $(document).ready(function () {

    // Example starter JavaScript for disabling form submissions if there are invalid fields
    (function () {
      'use strict'

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      let forms = document.querySelectorAll('.needs-validation');

      // Loop over them and prevent submission
      app.addValidationToForms(forms);

    })();

    $('#nav__night-mode').off('click').on('click', function () {
      $('body').toggleClass('night-mode');
    })
  });

  /**
   * Initiates an action when a button is clicked, showing a loading state, and then updates the notification element with progress.
   * @param {$button} $button - The button element that triggers the action.
   */
  app.doButtonAction = function ($button) {
    app.notify('success', 'Form Validated', true);
    app.button($button, 'loading');
    setTimeout(function () {
      app.notifyEl.update({'message': 'Request in Progress', progress: 33});
    }, 300);
  }

  /**
   * Resets the button state after an action is completed and optionally updates the notification element with a completion message.
   */
  app.doButtonReset = function ($button, isSuccess = true, progress = 100) {
    if (isSuccess) {
      app.notifyEl.update({'message': 'Request Completed', progress: progress});
    }
    app.button($button, 'reset');
  }

  app.doButtonResetDelayed = function ($button, isSuccess = true, progress = 100) {
    setTimeout(function (){
      app.doButtonReset($button, isSuccess, progress);
    }, 400);
  }

  /**
   * Retrieves the value of a query string parameter by name from a provided URL.
   * @param {string} name - The name of the parameter to retrieve.
   * @param {string} [url=window.location.href] - The URL to parse for the parameter, defaults to the current window's URL.
   * @returns {string|null} The value of the query string parameter, or null if not found.
   */
  app.getParameterByName = function (name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * Performs a file upload request to a specified URL with given request data, handling success and error with provided callbacks.
   * @param {string} url - The URL to send the request to.
   * @param {object} requestData - The data to be sent with the request.
   * @param {function} resolveFn - The callback function to execute on success.
   * @param {function} rejectFn - The callback function to execute on error.
   * @returns {Promise} A jQuery Deferred promise that resolves or rejects based on the request outcome.
   */
  app.fileUploadRequest = function (url, requestData, resolveFn, rejectFn) {
    let query = $.Deferred();
    let appTransport = app.transport();

    appTransport.setEvent('onSuccess', function (response) {
      resolveFn(response);
      return query.resolve(response);
    }).setEvent('onError', function (response) {
      rejectFn(response);
      return query.reject(response);
    }).setEvent('onProgress', function (event, response) {
      console.log(response);
    });

    appTransport.setRequestData(requestData, false)
    appTransport.post(url);
    return query.promise();
  }

  /**
   * Performs a POST request to a specified URL with given request data.
   * @param {string} url - The URL to send the request to.
   * @param {object} requestData - The data to be sent with the request.
   * @param {function} resolveFn - The callback function to execute on success.
   * @param {function} rejectFn - The callback function to execute on error.
   * @returns {Promise} A jQuery Deferred promise that resolves or rejects based on the request outcome.
   */
  app.postRequest = function (url, requestData, resolveFn, rejectFn, baseUrl = false, asJson = true) {
    let query = $.Deferred();
    let appTransport = app.transport();

    appTransport.setEvent('onSuccess', function (response) {
      resolveFn(response);
      return query.resolve(response);
    }).setEvent('onError', function (response) {
      rejectFn(response);
      return query.reject(response);
    });

    if(baseUrl !== false) {
      appTransport.setBaseUrl(baseUrl);
    }

    appTransport.setRequestData(requestData, asJson)
    appTransport.post(url);
    return query.promise();
  }

  /**
   * Performs a PUT request to a specified URL with given request data.
   * @param {string} url - The URL to send the request to.
   * @param {object} requestData - The data to be sent with the request.
   * @param {function} resolveFn - The callback function to execute on success.
   * @param {function} rejectFn - The callback function to execute on error.
   * @returns {Promise} A jQuery Deferred promise that resolves or rejects based on the request outcome.
   */
  app.putRequest = function (url, requestData, resolveFn, rejectFn, baseUrl = false) {
    let query = $.Deferred();
    let appTransport = app.transport();

    appTransport.setEvent('onSuccess', function (response) {
      resolveFn(response);
      return query.resolve(response);
    }).setEvent('onError', function (response) {
      rejectFn(response);
      return query.reject(response);
    });


    if(baseUrl !== false) {
      appTransport.setBaseUrl(baseUrl);
    }

    appTransport.put(url, requestData);
    return query.promise();
  }

  /**
   * Performs a GET request to a specified URL with given request data.
   * @param {string} url - The URL to send the request to.
   * @param {object} requestData - The data to be sent with the request.
   * @param {function} resolveFn - The callback function to execute on success.
   * @param {function} rejectFn - The callback function to execute on error.
   * @returns {Promise} A jQuery Deferred promise that resolves or rejects based on the request outcome.
   */
  app.getRequest = function (url, requestData, resolveFn, rejectFn, baseUrl = false, asJson = true) {
    app.stopWatch.start();
    let query = $.Deferred();
    let appTransport = app.transport();

    appTransport.setEvent('onSuccess', function (response) {
      resolveFn(response);
      return query.resolve(response);
    }).setEvent('onError', function (response) {
      rejectFn(response);
      return query.reject(response);
    }).setEvent('onComplete', function () {
      app.stopWatch.stop();
    });

    if(baseUrl !== false) {
      appTransport.setBaseUrl(baseUrl);
    }

    appTransport.get(url);
    appTransport.setRequestData(requestData, asJson)
    return query.promise();
  }



  /**
   * Performs a DELETE request to a specified URL.
   * @param {string} url - The URL to send the request to.
   * @param {object} requestData - The data to be sent with the request.
   * @param {function} resolveFn - The callback function to execute on success.
   * @param {function} rejectFn - The callback function to execute on error.
   * @returns {Promise} A jQuery Deferred promise that resolves or rejects based on the request outcome.
   */
  app.deleteRequest = function (url, requestData, resolveFn, rejectFn, baseUrl = false) {
    let query = $.Deferred();
    let appTransport = app.transport();

    appTransport.setEvent('onSuccess', function (response) {
      resolveFn(response);
      return query.resolve(response);
    }).setEvent('onError', function (response) {
      rejectFn(response);
      return query.reject(response);
    });

    if(baseUrl !== false) {
      appTransport.setBaseUrl(baseUrl);
    }

    appTransport.delete(url, requestData);
    return query.promise();
  }

  /**
   * Creates and manages a stopwatch timer functionality, allowing starting, stopping, and clearing the timer.
   * The timer's current value is displayed in an element with the id 'stopwatch'.
   *
   * @returns {object} An object containing methods to start, stop, and clear the stopwatch timer.
   */
  app.stopWatch = function () {
    let startTime = 0;
    let elapsedTime = 0;
    let timerInterval;

    function formatTime(time) {
      // Time in seconds
      let seconds = Math.floor(time / 1000);

      // Simulated microseconds (actual milliseconds)
      let microSeconds = (time % 1000) * 1000;

      // Zero padding
      let secFormatted = seconds.toString().padStart(2, "0");
      let microSecFormatted = microSeconds.toFixed(6);

      return `${secFormatted}:${microSecFormatted}`;
    }

    function printTime() {
      elapsedTime = performance.now() - startTime;
      const stopWatch = document.getElementById("stopwatch");
      if (stopWatch) {
        stopWatch.innerHTML = formatTime(elapsedTime);
      }
    }

    function startTimer() {
      if (!timerInterval) {
        startTime = performance.now() - elapsedTime;
        timerInterval = setInterval(printTime, 100); // Update interval. Browser may not honor 1ms.
      }
    }

    function stopTimer() {
      clearInterval(timerInterval);
      timerInterval = null;
      setTimeout(function () {
        clearTimer();
      }, 4000);
    }

    function clearTimer() {
      clearInterval(timerInterval);
      timerInterval = null;
      elapsedTime = 0;
      const stopWatch = document.getElementById("stopwatch");
      if (stopWatch) {
        stopWatch.innerHTML = "";
      }
    }

    return {
      start: startTimer, stop: stopTimer, clear: clearTimer
    }
  }()

  app.isEmpty = function (value) {
    if (value == null) return true; // Checks for null or undefined
    if (value === 'undefined') return true; // Checks for null or undefined
    if (value === false) return true; // Checks for null or undefined
    if (value === 0) return true; // Checks for null or undefined
    if (typeof value === 'string' && value.trim() === '') return true; // Checks for empty string (including spaces)
    if (Array.isArray(value) && value.length === 0) return true; // Checks for empty array
    if (Array.isArray(value) && value.every(val => val === null || val === undefined || val === "")) return true;
    if (value instanceof Object && Object.keys(value).length === 0) return true; // Checks for empty object

    return false;
  }
  /**
   * Triggers a click event on elements with the 'dropify-clear' class,
   * typically used to clear the value of a Dropify input field.
   */
  app.clearDropify = function () {
    $('.dropify-clear').trigger('click');
  }

  app.messageLoader = (function ($container) {
    let loaderElement = $('#messagesLoader');
    if (loaderElement.length) {
      loaderElement.remove();
    }

    let intervalId = null;
    const messages = ["Loading...", "Still working on it...", "Just a bit more...", "Almost done..."];
    let index = 0;

    loaderElement = $('<div class="loader-with-messages" id="messagesLoader"></div>');
    loaderElement.appendTo($container);

    function start() {
      if (intervalId !== null) return; // Prevent multiple intervals
      loaderElement.text(messages[index++]);
      intervalId = setInterval(function () {
        loaderElement.text(messages[index++]);
        if (index >= messages.length) index = 0;
      }, 2000);
    }

    function stop() {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function destroy() {
      stop(); // Stop the message cycle
      loaderElement.remove();
    }

    return {
      start: start,
      stop: stop,
      destroy: destroy
    };
  });

  function getCallerInfo() {
    const error = new Error();
    const stackLines = error.stack.split('\n');

    // Skip the first line (it's the error message itself)
    // Second line is the current function
    // Third line is the caller function
    if (stackLines[2]) {
      const callerInfo = stackLines[2].trim();
      return callerInfo;
    }

    return 'Caller information not available';
  }


  app.initSimpleBar = function (element) {
    if(typeof element === 'undefined') {
      console.log(element);
      console.log('Trying to init simple bar on undefined element', getCallerInfo());
      return false;
    } else if (typeof element.SimpleBar === 'undefined') {
      new SimpleBar(element, {autoHide: true});
      element.SimpleBar = true;
    } else {

    }
  }

  app.initTooltip = function () {
    $('[data-bs-toggle="tooltip"]').tooltip();
  }

  app.initRadioSwitches = function ($container) {
    const $radios = $('.form-switch input[type=radio]', $container);
    let names = []
    _.each($radios, function (radio) {
      names.push(radio.getAttribute('name'))
    })
    const radioNames = _.unique(names);
    _.each(radioNames, function (name) {
      const $radios = $(`.form-switch input[type=radio][name="${name}"]`, $container);

      _.each($radios, function (radio) {
        const target = radio.getAttribute('data-bs-target');
        radio.addEventListener('change', function (e) {
          const $radios = $(`.form-switch input[type=radio][name="${e.target.getAttribute('name')}"]`, $container);
          _.each($radios, function (radioInput) {

            const target = radioInput.getAttribute('data-bs-target');
            if (target) {
              const collapse = bootstrap.Collapse.getOrCreateInstance(target, {
                toggle: false // Initialize without toggling the current state.
              });
              if (radioInput.checked) {
                collapse.show();
              } else {
                collapse.hide();
              }
            }

          });
        });
      })
    })
  }

  app.redirect = function (href) {
    window.location.href = href;
  }

  app.reload = function (href) {
   window.location.reload(true);
  }

  // Function to update the character count
  app.updateCharCount = (textArea, charCount) => {
    charCount.textContent = textArea.value.length;
  };

  app.removeItem = function ($item, animation = 'hinge') {
    $item.addClass(`animated ${animation}`);
    setTimeout(function () {
      $item.remove();
    }, 1000);
  }


  // assign global
  globals[app.application.namespace] = app;

})(window);
